import { selectPlanLearnings } from './plan-learnings';

import { useBrandKits } from '@/hooks/useBrandKits';
import { useWorkspaceLearnings } from '@/hooks/useWorkspaceLearnings';
import { ITEM_META, SECTION_LABEL } from '@/lib/ui-tokens';

/**
 * "What Mora has learned" — up to three active learnings for the workspace the
 * project is being created in. Renders nothing when there are none: an empty
 * list is a fixture gap, not a verdict, so no empty-state copy is shown.
 */
export function PlanLearningsNote({ brandKitId }: { brandKitId?: string | null }) {
  const { activeKit } = useBrandKits();
  const kitId = brandKitId ?? activeKit?.id ?? null;
  const { data } = useWorkspaceLearnings(kitId);
  const rows = selectPlanLearnings(data);
  if (rows.length === 0) return null;

  return (
    <section aria-label="What Mora has learned" className="flex flex-col gap-1.5">
      <p className={SECTION_LABEL}>What Mora has learned</p>
      <ul className="flex flex-col gap-1.5">
        {rows.map((row) => (
          <li key={row.id} className="rounded-lg bg-muted/50 px-3 py-2 text-detail">
            <span className="text-foreground">{row.claim}</span>
            <span className={`${ITEM_META} block`}>{row.confidenceLabel}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
